import request from "@/utils/http";

// 添加套餐
export function addMembersPackage(data) {
  return request.post("/promotionOffline/add", data);
}

// 修改套餐
export function membersPackageEdit(data) {
  return request.post("/promotionOffline/update", data);
}

// 套餐列表
export function membersPackageList() {
  return request.get("/promotionOffline/list").then(res => res.result);
}

// 删除套餐
export function deleteMembersPackage(id) {
  return request.post(`/promotionOffline/delete/${id}`);
}

// 套餐详情
export function membersPackageDetail(id) {
  return request.get(`/promotionOffline/${id}`).then(res => res.result);
}

// 开通套餐
export function dredgeCombo(query) {
  return request.post(
    `/promotionOffline/record?id=${query.id}&phone=${query.phone}&validTime=${query.validTime}`
  );
}

// 套餐购买列表
export function comboList(listQuery) {
  return request
    .get(`/promotionOffline/record/list?userPhone=${listQuery.phone}`)
    .then(res => res.result);
}

// 套餐购买详情
export function comboDetail(id) {
  return request.get(`/promotionOffline/record/${id}`).then(res => res.result);
}
